// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3zC8d","header":"Messages_header__2BS48"};